import { BookingAttempt, BookingAttemptMetrics } from 'model/BookingAttempt';

export interface BookingAttemptsState {
    loading: boolean;
    bookingAttempts: Array<BookingAttempt>;
    pagination?: BookingAttemptsPagination;
    metrics?: BookingAttemptMetrics;
    status: BookingAttemptsStatus;
}

export interface BookingAttemptsPagination {
    page: number;
    size: number;
    totalPages: number;
    totalRecords: number;
}

export enum BookingAttemptsStatus {
    Initial,

    Error,

    FetchStart,
    FetchSuccess,

    MetricsFetchStart,
    MetricsFetchSuccess
}
